module.exports = __webpack_public_path__ + "img/next.21ad11ff.svg";